import { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import CourseCard from '../components/common/CourseCard';
import FAQ from '../components/common/FAQ';
import OurStory from '../components/common/OurStory';
import OurPrograms from '../components/common/OurPrograms';
import {
  FaClock,
  FaUser,
  FaGift,
  FaChalkboardTeacher,
  FaGlobe,
  FaLaptop,
  FaChevronDown,
  FaPlay,
  FaStar,
  FaCheckCircle
} from 'react-icons/fa';
import {
  homeCourses,
  freeResources,
  keyFeatures,
  stats,
  steps,
  faqs
} from '../data/homeData';
// import { getRecentPosts } from '../data/blogData';
import './Home.css';

const Home = () => {
  const [visibleSections, setVisibleSections] = useState(new Set());
  // const featuredPosts = getRecentPosts(3);
  const sectionRefs = useRef({});

  useEffect(() => {
    const observers = [];
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };

    const observerCallback = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setVisibleSections((prev) => new Set([...prev, entry.target.id]));
        }
      });
    };

    Object.values(sectionRefs.current).forEach((ref) => {
      if (ref) {
        const observer = new IntersectionObserver(observerCallback, observerOptions);
        observer.observe(ref);
        observers.push(observer);
      }
    });

    return () => {
      observers.forEach((observer) => observer.disconnect());
    };
  }, []);

  const featureIcons = {
    schedule: <FaClock />,
    personalized: <FaUser />,
    trial: <FaGift />,
    teacher: <FaChalkboardTeacher />,
    language: <FaGlobe />,
    device: <FaLaptop />
  };

  return (
    <div className="home-page">
      {/* Hero Section */}
      <section className="hero-section" id="hero">
        <div className="hero-background">
          <div className="hero-gradient"></div>
          <div className="hero-pattern"></div>
        </div>
        <div className="container">
          <div className="hero-content">
            <div className="hero-badge">
              <FaStar className="star-icon" />
              <span>Trusted by 3000+ Students Worldwide</span>
            </div>
            <h1 className="hero-title">
              <span className="title-line">ALNoor Tutors</span>
              <span className="title-highlight">Learn Quran Online</span>
              <span className="title-line">with Expert Tutors</span>
            </h1>
            <p className="hero-description">
              Join the best ALNoor Tutors to learn Quran online with
              expert tutors. Get Islamic education from the comfort of your
              home with flexible schedules and personalized one-on-one classes.
            </p>
            <div className="hero-buttons">
              <Link to="/free-trial" className="btn btn-hero-primary">
                <span>BOOK FREE TRIAL</span>
                <FaCheckCircle className="btn-icon" />
              </Link>
              <Link to="/courses" className="btn btn-hero-outline">
                <span>BROWSE COURSES</span>
              </Link>
            </div>
            <div className="hero-stats">
              {stats.slice(0, 3).map((stat, index) => (
                <div key={index} className="hero-stat-item">
                  <span className="hero-stat-value">{stat.value}</span>
                  <span className="hero-stat-label">{stat.label}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="hero-scroll-indicator">
          <div className="scroll-arrow"></div>
        </div>
      </section>

      {/* Why Choose Section */}
      <section 
        className={`why-choose-section section ${visibleSections.has('why-choose') ? 'visible' : ''}`}
        id="why-choose"
        ref={(el) => (sectionRefs.current['why-choose'] = el)}
      >
        <div className="container">
          <div className="section-title">
            <span className="section-badge">Why Choose Us</span>
            <h2>Why Choose Our ALNoor Tutors?</h2>
            <p className="section-subtitle">
              Experience excellence in Islamic education with our proven methodology
            </p>
          </div>
          <div className="why-choose-content">
            <div className="why-choose-text">
            <p>
                Welcome to ALNoor Tutors. Here you can learn
              all Islamic and Quranic education at one place. Our online Quran
              academy has made learning & teaching the Quran very simple.
              Because we are using latest technology like internet skype zoom &
              whiteboard. So you can take online Quran classes anywhere and at
              any time. And start learn Quran online.
            </p>
            <p>
              Reading & understanding the Quran are both crucial. You need to
              understand the Quran to know why Allah revealed it and which path
              leads to guidance. Allah has said in the Quran that seeking
              knowledge is necessary for every man & woman. In today's busy
              life, making time for Islamic education is extremely challenging.
              And some countries have very few Islamic institutions and mosques,
              especially US UK Australia Europe, etc. But now, you can get Quran
              education from your home. You and your children can learn through
              online classes from anywhere in the world.
            </p>
            </div>
            <div className="why-choose-features">
              <div className="feature-highlight">
                <FaCheckCircle className="highlight-icon" />
                <span>24/7 Flexible Scheduling</span>
              </div>
              <div className="feature-highlight">
                <FaCheckCircle className="highlight-icon" />
                <span>One-on-One Personalized Classes</span>
              </div>
              <div className="feature-highlight">
                <FaCheckCircle className="highlight-icon" />
                <span>Certified & Experienced Teachers</span>
              </div>
              <div className="feature-highlight">
                <FaCheckCircle className="highlight-icon" />
                <span>Free Trial Classes Available</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Video Section */}
      {/* <section 
        className={`video-section section ${visibleSections.has('video') ? 'visible' : ''}`}
        id="video"
        ref={(el) => (sectionRefs.current['video'] = el)}
      >
        <div className="container">
          <div className="section-title">
            <span className="section-badge">See It In Action</span>
            <h2>Watch how our online Quran classes work!</h2>
            <p className="section-subtitle">
              Experience our interactive learning platform in action
            </p>
          </div>
          <div className="video-placeholder">
            <div className="video-thumbnail">
              <div className="play-button-wrapper">
                <div className="play-button">
              <FaPlay className="play-icon" />
                </div>
                <div className="play-ripple"></div>
              </div>
              <p>Video demonstration of our online classes</p>
            </div>
          </div>
        </div>
      </section> */}

      {/* Our Programs Section */}
      <OurPrograms
        courses={homeCourses}
        title="Our Courses"
        badge="Our Programs"
        subtitle="Explore our comprehensive list of Quran courses online to get started today"
        showMoreLink="/courses"
        maxDisplay={3}
      />

      {/* Free Resources Section */}
      <section 
        className={`free-resources-section section ${visibleSections.has('resources') ? 'visible' : ''}`}
        id="resources"
        ref={(el) => (sectionRefs.current['resources'] = el)}
      >
        <div className="container">
          <div className="section-title">
            <span className="section-badge">Free Learning Tools</span>
            <h2>Start Learning with Free Resources</h2>
            <p className="section-subtitle">
              Access our collection of free Islamic learning materials
            </p>
          </div>
          <div className="resources-scroll">
            <div className="resources-list">
              {freeResources.map((resource, index) => (
              <Link
                key={resource.id}
                to={resource.path}
                  className={`resource-pill ${visibleSections.has('resources') ? 'visible' : ''}`}
                  style={{ animationDelay: `${index * 0.05}s` }}
              >
                <span className="resource-icon">{resource.icon}</span>
                <span className="resource-title">{resource.title}</span>
              </Link>
            ))}
            </div>
          </div>
        </div>
      </section>

      {/* Key Features Section */}
      <section 
        className={`key-features-section section ${visibleSections.has('features') ? 'visible' : ''}`}
        id="features"
        ref={(el) => (sectionRefs.current['features'] = el)}
      >
        <div className="decorative-shape-1"></div>
        <div className="decorative-shape-2"></div>
        <div className="decorative-shape-3"></div>
        <div className="grid-pattern"></div>
        <div className="container">
          <div className="section-title">
            <span className="section-badge">Key Features</span>
            <h2>ALNoor Tutors Key Features</h2>
            <p className="section-subtitle">
              Everything you need for an exceptional learning experience
            </p>
          </div>
          <div className="features-list">
            {keyFeatures.map((feature, index) => (
              <div 
                key={feature.id} 
                className={`feature-item ${visibleSections.has('features') ? 'visible' : ''}`}
                style={{ animationDelay: `${index * 0.08}s` }}
              >
                <div className="feature-icon">
                  {featureIcons[feature.icon] || <FaGlobe />}
                </div>
                <div className="feature-content">
                <h3>{feature.title}</h3>
                <p>{feature.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Our Story Section */}
      <OurStory
        title="About ALNoor Tutors"
        badge="Our Story"
        paragraphs={[
          "We established ALNoor Tutors in 2000, starting as an offline Quran school. From the beginning, we planned to make Quranic education accessible to Muslims worldwide. Then a few years later, we transitioned our academy online to reach more students.",
          "Thousands of students have completed their Quranic & Islamic education with us. And they received certificates. Currently, hundreds of students are enrolled in our courses.",
          "We provide live classes through Skype and Zoom. Our Quran teachers offer all Islamic and Quranic courses, like Quran Memorization, Recitation, Basic Reading, Tajweed, Qirat, Tafseer, Arabic Language, and Noorani Qaida. ALNoor Tutors aim to build your deep spiritual connection with the Quran."
        ]}
      />

      {/* 3 Steps Section */}
      <section 
        className={`steps-section section ${visibleSections.has('steps') ? 'visible' : ''}`}
        id="steps"
        ref={(el) => (sectionRefs.current['steps'] = el)}
      >
        <div className="container">
          <div className="section-title">
            <span className="section-badge">Get Started</span>
            <h2>3 Easy Steps To Learn Quran Online</h2>
            <p className="section-subtitle">
              Start your journey with ALNoor Tutors in just three simple steps
            </p>
          </div>
          <div className="steps-grid">
            {steps.map((step, index) => (
              <div 
                key={step.step} 
                className={`step-card ${visibleSections.has('steps') ? 'visible' : ''}`}
                style={{ animationDelay: `${index * 0.15}s` }}
              >
                <div className="step-number-badge">
                  <span className="step-number">{step.step}</span>
                </div>
                <div className="step-content">
                <h3>{step.title}</h3>
                <p>{step.description}</p>
                {step.cta && (
                  <Link to="/free-trial" className="btn btn-secondary">
                      <span>{step.cta}</span>
                  </Link>
                )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Featured Blog Section */}
      {/* <section 
        className={`blog-section section ${visibleSections.has('blog') ? 'visible' : ''}`}
        id="blog"
        ref={(el) => (sectionRefs.current['blog'] = el)}
      >
        <div className="container">
          <div className="section-title">
            <span className="section-badge">Latest Articles</span>
            <h2>Featured Islamic Blog Posts</h2>
            <p className="section-subtitle">
              Read top free Islamic articles & blog posts on the Internet
            </p>
          </div>
          <div className="blog-list">
            {featuredPosts.map((post, index) => (
              <Link
                key={post.id}
                to={`/blog/${post.slug}`}
                className={`blog-item ${visibleSections.has('blog') ? 'visible' : ''}`}
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className="blog-thumbnail">
                  <img
                    src={post.image || '/placeholder-course.jpg'}
                    alt={post.title}
                  />
                </div>
                <div className="blog-info">
                  <h3>{post.title}</h3>
                  <p>{post.excerpt}</p>
                  <span className="blog-link">
                    Read Article <FaChevronDown className="link-icon" />
                  </span>
                </div>
              </Link>
            ))}
          </div>
          <div className="text-center mt-4">
            <Link to="/blog" className="btn btn-secondary">
              <span>View All Blog Posts</span>
            </Link>
          </div>
        </div>
      </section> */}

      {/* FAQs Section */}
      <FAQ 
        faqs={faqs}
        title="Frequently Asked Questions"
        subtitle="Find answers to common questions about our ALNoor Tutors"
      />

      {/* CTA Section */}
      <section 
        className={`cta-section ${visibleSections.has('cta') ? 'visible' : ''}`}
        id="cta"
        ref={(el) => (sectionRefs.current['cta'] = el)}
      >
        <div className="cta-background">
          <div className="cta-gradient"></div>
          <div className="cta-pattern"></div>
        </div>
        <div className="container">
          <div className="cta-content">
            <h2>Ready to Start Your Quran Learning Journey?</h2>
            <p>Join thousands of students learning Quran online with expert tutors</p>
            <Link to="/free-trial" className="btn btn-cta-primary">
              <span>BOOK FREE TRIAL</span>
              <FaGift className="btn-icon" />
            </Link>
            <div className="cta-trust-badges">
              <div className="trust-badge">
                <FaCheckCircle />
                <span>No Credit Card Required</span>
              </div>
              <div className="trust-badge">
                <FaCheckCircle />
                <span>100% Free Trial</span>
              </div>
              <div className="trust-badge">
                <FaCheckCircle />
                <span>Cancel Anytime</span>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
